module.exports = __webpack_public_path__ + "static/media/pic-ht11.830fd2ac.jpg";